<ng-container *ngFor="let validation of validations">
    <ng-container *ngIf="ifHasErrors(form, controlName, validation.type)">
        <p class="mt-1 text-danger">{{ validation.message }}</p>
    </ng-container>
</ng-container>
